import { render, staticRenderFns } from "./PaymentRequestForm.vue?vue&type=template&id=731145ba&scoped=true&"
import script from "./PaymentRequestForm.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestForm.vue?vue&type=style&index=0&id=731145ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731145ba",
  null
  
)

export default component.exports